module.exports = __webpack_public_path__ + "static/media/checkbox-selected.efda909e.svg";